import React from "react";
import { MET_SHARE } from "../presence";
import { useHomeLang } from "../homeLang";

// The caption's words, round the share and the count they are given.
const CAPTION = {
  it: {
    met: (share) => <>In un anno ne incontri circa il {share}?</>,
    today: (count) => <>Gli altri {count} non ti vedono.</>,
    avrah: (count) => <>Gli altri {count} ti vedono <span className="hv-keep">ogni mese</span>, in un tuo video.</>,
  },
  en: {
    met: (share) => <>You meet about {share} of them in a year?</>,
    today: (count) => <>The other {count} never see you.</>,
    avrah: (count) => <>The other {count} see you <span className="hv-keep">every month</span>, in a video from you.</>,
  },
};

// PROTOTYPE (hero v2): the disc's caption, one sentence per element, so the
// layout can set each on its own line or either side of the disc.
// The second sentence has two versions, today's and AVRAH's, stacked in one
// cell, so the cell always keeps the longer one's room and they cross-fade in
// place. Only the current version is exposed to assistive technology, and
// the paragraph announces the change. The first sentence asks after the
// share of clients you meet, the same for every book, and is set quieter
// than the second, which answers with the ones who never see you.
export default function PresenceAnswerV2({ others, lit }) {
  const share = <span className="hv-strong">{Math.round(MET_SHARE * 100)}%</span>;
  const count = <span className="hv-others">{others}</span>;
  const countLit = <span className="hv-others hv-others-lit">{others}</span>;
  const { met, today, avrah } = CAPTION[useHomeLang()];
  return (
    <p className="hv-answer" aria-live="polite">
      <span className="hv-met">{met(share)}</span>{" "}
      <span className="hv-then">
        <span data-on={!lit} aria-hidden={lit || undefined}>
          {today(count)}
        </span>{" "}
        <span data-on={lit} aria-hidden={!lit || undefined}>
          {avrah(countLit)}
        </span>
      </span>
    </p>
  );
}
